import { Component, Input } from '@angular/core';
import { LoadingProgressInduxtry } from '../../../../../utils/models/common.interface';

@Component({
  selector: 'loading-progress-induxtry',
  templateUrl: './loading-progress.component.html',
  styleUrls: ['./loading-progress.component.scss']
})
export class LoadingProgressComponent {
  @Input() loading: LoadingProgressInduxtry;
}
